/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Custom Hostname
 */
export interface CustomDomain { 
    cookie_domain?: string;
    cors_allowed_origins?: Array<string>;
    cors_enabled?: boolean;
    created_at?: string;
    custom_ui_base_url?: string;
    hostname?: string;
    id?: string;
    ssl_status?: CustomDomain.SslStatusEnum;
    updated_at?: string;
    verification_errors?: Array<string>;
    verification_status?: string;
}
export namespace CustomDomain {
    export type SslStatusEnum = 'initializing' | 'pending_validation' | 'deleted' | 'pending_issuance' | 'pending_deployment' | 'pending_deletion' | 'pending_expiration' | 'expired' | 'active' | 'initializing_timed_out' | 'validation_timed_out' | 'issuance_timed_out' | 'deployment_timed_out' | 'deletion_timed_out' | 'pending_cleanup' | 'staging_deployment' | 'staging_active' | 'deactivating' | 'inactive' | 'backup_issued' | 'holding_deployment' | '';
    export const SslStatusEnum = {
        Initializing: 'initializing' as SslStatusEnum,
        PendingValidation: 'pending_validation' as SslStatusEnum,
        Deleted: 'deleted' as SslStatusEnum,
        PendingIssuance: 'pending_issuance' as SslStatusEnum,
        PendingDeployment: 'pending_deployment' as SslStatusEnum,
        PendingDeletion: 'pending_deletion' as SslStatusEnum,
        PendingExpiration: 'pending_expiration' as SslStatusEnum,
        Expired: 'expired' as SslStatusEnum,
        Active: 'active' as SslStatusEnum,
        InitializingTimedOut: 'initializing_timed_out' as SslStatusEnum,
        ValidationTimedOut: 'validation_timed_out' as SslStatusEnum,
        IssuanceTimedOut: 'issuance_timed_out' as SslStatusEnum,
        DeploymentTimedOut: 'deployment_timed_out' as SslStatusEnum,
        DeletionTimedOut: 'deletion_timed_out' as SslStatusEnum,
        PendingCleanup: 'pending_cleanup' as SslStatusEnum,
        StagingDeployment: 'staging_deployment' as SslStatusEnum,
        StagingActive: 'staging_active' as SslStatusEnum,
        Deactivating: 'deactivating' as SslStatusEnum,
        Inactive: 'inactive' as SslStatusEnum,
        BackupIssued: 'backup_issued' as SslStatusEnum,
        HoldingDeployment: 'holding_deployment' as SslStatusEnum,
        Empty: '' as SslStatusEnum
    };
}


